import "./BannerSlider.css";
import { useEffect, useState } from 'react';
export type BannerSlide = { id: string; imageUrl: string; alt: string; durationSeconds: number };
export function BannerSlider({ slides, label, className = '' }: { slides: BannerSlide[]; label: string; className?: string }) {
  const signature = JSON.stringify(slides.map(s => [s.id,s.imageUrl,s.durationSeconds]));
  const [index,setIndex] = useState(0);
  const [paused,setPaused] = useState(false);
  const [allowMotion,setAllowMotion] = useState(false);
  const [focused,setFocused] = useState(false);
  const [hovered,setHovered] = useState(false);
  const [hidden,setHidden] = useState(false);
  const [reducedMotion,setReducedMotion] = useState(false);
  useEffect(()=>{setIndex(0);},[signature]);
  useEffect(()=>{
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = ()=>setReducedMotion(motion.matches);
    const visibility = ()=>setHidden(document.hidden);
    update();visibility();
    motion.addEventListener('change',update);document.addEventListener('visibilitychange',visibility);
    return ()=>{motion.removeEventListener('change',update);document.removeEventListener('visibilitychange',visibility);};
  },[]);
  const current = slides[index] || slides[0];
  useEffect(()=>{
    if(slides.length<2||paused||focused||hovered||hidden||(reducedMotion&&!allowMotion)||!current)return;
    const timer=window.setTimeout(()=>setIndex(i=>(i+1)%slides.length),Math.max(2,Math.min(300,Number(current.durationSeconds)||8))*1000);
    return ()=>window.clearTimeout(timer);
  },[signature,index,paused,focused,hovered,hidden,reducedMotion,allowMotion]);
  if(!current)return null;
  return <section className={`banner-slider ${className}`} aria-roledescription="carrusel" aria-label={label} onMouseEnter={()=>setHovered(true)} onMouseLeave={()=>setHovered(false)} onFocusCapture={()=>setFocused(true)} onBlurCapture={e=>{if(!e.currentTarget.contains(e.relatedTarget as Node))setFocused(false);}}>
    <img src={current.imageUrl} alt={current.alt||label} />
    <strong className="banner-slider-name">{current.alt}</strong>
    {slides.length>1&&<div className="banner-slider-controls"><button type="button" aria-label="Banner anterior" onClick={()=>setIndex(i=>(i-1+slides.length)%slides.length)}>‹</button><span>{Math.min(index,slides.length-1)+1} / {slides.length}</span><button type="button" aria-label="Banner siguiente" onClick={()=>setIndex(i=>(i+1)%slides.length)}>›</button><button type="button" aria-pressed={paused || (reducedMotion&&!allowMotion)} onClick={()=>{if(reducedMotion&&!allowMotion){setAllowMotion(true);setPaused(false);}else setPaused(p=>!p);}}>{paused || (reducedMotion&&!allowMotion)?'Reanudar':'Pausar'}</button></div>}
  </section>;
}
